import { ContentContainer } from 'components/styles_components/container';

const Container = ({ children, maxWidth = 'xl' }) => {
  return (
    <ContentContainer maxWidth={maxWidth} sx={{ px: { xs: 0, sm: 2 } }}>
      {children}
    </ContentContainer>
  );
};

export default Container;
